export enum LotteryTypes {
    Lottery = 'lottery',
    Keno = 'keno',
    Pick = 'pick',
    RaffleClosed = 'raffle-closed',
    RaffleOpen = 'raffle-open',
    Soccer = 'soccer',
}
